// Lists configured payment processors. Kept as `usePaymentProcessors` because the threshold-edit
// UI on `ProcessorRateSettingsPage` still needs the processor list.

import type { PaymentProcessorListItemDto } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { campaignHeaders, defineQuery } from '../../lib/data';

const paymentProcessorsRead = defineQuery({
  key: () => ['finance', 'processors'],
  reads: 'GET /api/finance/processors',
  fetch: (_: undefined, { signal, campaignId }) =>
    apiJson<PaymentProcessorListItemDto[]>('/api/finance/processors', {
      signal,
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch payment processors',
    }),
});

export function usePaymentProcessors() {
  return paymentProcessorsRead(undefined);
}
